module.exports = {
	"version": "1.3.5"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/poly2tri/dist/version.json
 ** module id = 169
 ** module chunks = 1
 **/